// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CldR","type":"styles_type__2t4IH","choices":"styles_choices__1BZuF"};